import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "assignment-details" }
const _hoisted_2 = { class: "extension-notes" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", null, "Things to Note:", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", null, " Tandem does not automatically notify students of a deadline extension. ", -1)
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { class: "detail-item" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Student Time Commitment: ", -1)
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "detail-item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("b", null, "Purpose:", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tandem_date_input = _resolveComponent("tandem-date-input")!
  const _component_planner_event_card = _resolveComponent("planner-event-card")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_planner_event_card, { event: _ctx.calendarEvent }, {
      dates: _withCtx(() => [
        _createVNode(_component_tandem_date_input, {
          name: "due-date",
          label: "Due Date",
          "help-text": "This assignment will be due at 11:59PM.",
          "min-date": _ctx.originalDueDate,
          defaults: { hour: 23, minute: 59 },
          modelValue: _ctx.dueDate,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.dueDate) = $event))
        }, null, 8, ["min-date", "modelValue"]),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            (_ctx.isLesson)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Tandem does not automatically notify students of a deadline extension. "))
              : (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                  _hoisted_6,
                  (_ctx.assignment.type === _ctx.EventTypeCategory.TeamCheck)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_7, " Extending the deadline on a Team Check may require you to move the release date of the following System Automated lesson. "))
                    : _createCommentVNode("", true),
                  (_ctx.assignment.surveyType === _ctx.SurveyType.BoT)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_8, " Extending the deadline on the Beginning of Term Survey may require you to move the Teams Visible date. "))
                    : _createCommentVNode("", true),
                  (_ctx.assignment.surveyType === _ctx.SurveyType.EoT)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_9, " Extending the deadline on the End of Term Feedback Survey may require you to move the release date of the End of Term Reflection lesson. "))
                    : _createCommentVNode("", true),
                  (_ctx.assignment.surveyType === _ctx.SurveyType.Midterm)
                    ? (_openBlock(), _createElementBlock("li", _hoisted_10, " Extending the deadline on the Midterm Feedback Survey may require you to move the release date of the Midterm Reflection lesson. "))
                    : _createCommentVNode("", true)
                ]))
          ])
        ])
      ]),
      description: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("p", null, [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_ctx.assignment.timeCommitment.time || "Not Available") + " ", 1),
            (_ctx.assignment.timeCommitment.comment)
              ? (_openBlock(), _createElementBlock("span", _hoisted_13, "(" + _toDisplayString(_ctx.assignment.timeCommitment.comment) + ")", 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("p", null, [
            _hoisted_15,
            _hoisted_16,
            _createTextVNode(" " + _toDisplayString(_ctx.assignment.purpose || "Not Available"), 1)
          ])
        ])
      ]),
      buttons: _withCtx(() => [
        (_ctx.calendarEvent.extendedProps.deletable)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-cancel",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('remove', _ctx.calendarEvent)))
            }, " Remove "))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "btn btn-burg",
          onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
        }, " Update ")
      ]),
      _: 1
    }, 8, ["event"])
  ]))
}